import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import clsx from 'clsx'
import Loader from 'components/loader'
import env from 'config/env'
import Typo from 'constants/typography'
import { hasLocizeTranslation } from 'lib/utils/locize'
import GoogleMapLocation from './google-map-location'
import LocationFilter from './location-filter'
import styles from './style.scss'

export const GOOGLE_MAP_URL = `https://maps.googleapis.com/maps/api/js?key=${env.GOOGLE_API_KEY}&libraries=places`
export const GOOGLE_MAP_SCRIPT_ID = 'google_map_script'

class GoogleMapSearchFilter extends React.PureComponent {
  static GET_PICKUP_LOCATIONS = 'GET_TH_PICKUP'

  static PICKUP_TYPES = 'store|pin'

  state = {
    allLocations: null,
    filteredLocations: null,
    selectedLocation: null,
    currentLocation: null,
    searchedLocation: null,
    isLoading: true,
  }

  async componentDidMount() {
    this.loadGoogleMapScript(
      GOOGLE_MAP_SCRIPT_ID,
      GOOGLE_MAP_URL,
      this.setStopLoading,
    )
    const { hideTempDisabled, locations } = this.props
    let pickupLocations = locations

    if (pickupLocations) {
      if (pickupLocations && hideTempDisabled) {
        pickupLocations = this.getEnabledLocations(pickupLocations)
      }

      this.setState({ allLocations: pickupLocations })
    }
  }

  setSelectedLocation = (location) => {
    this.setState({ selectedLocation: location })
  }

  setFilteredLocation = (locations) => {
    this.setState({ filteredLocations: locations })
  }

  setCurrentLocation = (location) => {
    this.setState({ currentLocation: location })
  }

  setSearchedLocation = (location) => {
    this.setState({ searchedLocation: location })
  }

  getEnabledLocations = (locations) => {
    const enabledLocations = locations.filter(
      (location) => location.status === 'active',
    )
    return enabledLocations
  }

  setStopLoading = () => {
    this.setState({ isLoading: false })
  }

  isGoogleMapsLoaded = () => window && window.google && window.google.maps

  loadGoogleMapScript(scriptId, src, onLoadFn) {
    if (
      (document && document.getElementById(scriptId)) ||
      this.isGoogleMapsLoaded()
    ) {
      this.setStopLoading()
      return
    }

    const script = document.createElement('script')
    script.setAttribute('src', src)
    script.setAttribute('id', scriptId)
    script.setAttribute('async', true)
    script.onload = onLoadFn
    document.body.appendChild(script)
  }

  render() {
    const { isLoading } = this.state
    const { t, id, showCoachMark, setCoachMark } = this.props

    if (isLoading) {
      return (
        <div
          className="google-map-search-filter-component loader-component"
          id={id}
        >
          <style jsx>{styles}</style>
          <Loader />
        </div>
      )
    }

    const {
      allLocations,
      selectedLocation,
      filteredLocations,
      currentLocation,
      searchedLocation,
    } = this.state

    return (
      <div className="google-map-search-filter-component" id={id}>
        <style jsx>{styles}</style>
        <span className={clsx(Typo.h4, 'gmsfc__title')}>
          {hasLocizeTranslation(t, 'GMSFC_ALL_LOCATIONS', 'Where to find us')}
        </span>
        <div className="gmsfc__map-filter-area" id="gmsfc__map-filter-area">
          <GoogleMapLocation
            locations={allLocations}
            setSelectedLocation={this.setSelectedLocation}
            setFilteredLocation={this.setFilteredLocation}
            setCurrentLocation={this.setCurrentLocation}
            selectedLocation={selectedLocation}
            filteredLocations={filteredLocations}
            currentLocation={currentLocation}
            searchedLocation={searchedLocation}
          />
          <LocationFilter
            locations={allLocations}
            setSelectedLocation={this.setSelectedLocation}
            setFilteredLocation={this.setFilteredLocation}
            setCurrentLocation={this.setCurrentLocation}
            setSearchedLocation={this.setSearchedLocation}
            selectedLocation={selectedLocation}
            filteredLocations={filteredLocations}
            currentLocation={currentLocation}
            maxFilteredData="10"
            showCoachMark={showCoachMark}
            setCoachMark={setCoachMark}
          />
        </div>
      </div>
    )
  }
}

GoogleMapSearchFilter.defaultProps = {
  hideTempDisabled: true,
  showCoachMark: false,
  id: '',
  locations: undefined,
  setCoachMark: undefined,
}

GoogleMapSearchFilter.propTypes = {
  t: PropTypes.func.isRequired,
  hideTempDisabled: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.shape({})),
  id: PropTypes.string,
  showCoachMark: PropTypes.bool,
  setCoachMark: PropTypes.func,
}

export { GoogleMapSearchFilter }
const Extended = translate('global')(GoogleMapSearchFilter)

export default connect(
  /* istanbul ignore next */
  (state) => state,
)(Extended)
